import { createContext, memo, useCallback, useContext } from 'react'
import { EmojiPicker } from 'frimousse'
import { cn } from '@/lib/utils'
const SelectedEmojisContext = createContext([])
const HIDDEN_CATEGORY_HEADER_HEIGHT = 1
const ReactionPickerCategoryHeader = ({ ...props }) => (
  <div
    {...props}
    aria-hidden="true"
    className={cn(
      props.className,
      'pointer-events-none overflow-hidden p-0 m-0 text-transparent select-none',
    )}
    style={{
      ...props.style,
      height: HIDDEN_CATEGORY_HEADER_HEIGHT,
      minHeight: HIDDEN_CATEGORY_HEADER_HEIGHT,
      margin: 0,
      padding: 0,
      position: 'relative',
      top: 'auto',
      backdropFilter: 'none',
      background: 'transparent',
      lineHeight: 0,
      fontSize: 0,
    }}
  />
)
const ReactionPickerEmoji = ({ emoji, ...props }) => {
  const selectedEmojis = useContext(SelectedEmojisContext)
  const isSelected = selectedEmojis.includes(emoji.emoji)
  return (
    <button
      {...props}
      className={cn(
        'group relative w-10 h-10 flex items-center justify-center rounded-md cursor-default',
        isSelected ? 'bg-primary/10' : 'hover:bg-muted/50',
      )}
    >
      <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        <span className="absolute inset-0 flex items-center justify-center blur-lg saturate-200 scale-150 opacity-50">
          {emoji.emoji}
        </span>
      </div>
      <span className="relative z-10 text-2xl transition-transform">{emoji.emoji}</span>
    </button>
  )
}
const ReactionPickerSearch = () => (
  <div className="p-2">
    <EmojiPicker.Search
      className="w-full h-8 px-3 rounded-md bg-muted/50 border-none text-xs focus:outline-none focus:ring-2 focus:ring-primary/20 placeholder:text-muted-foreground/50"
      placeholder="Search emojis..."
    />
  </div>
)
const ReactionPickerViewport = () => (
  <EmojiPicker.Viewport className="flex-1 w-full overflow-y-auto px-2 pb-2 min-h-0 scrollbar-none">
    <EmojiPicker.List
      components={{
        CategoryHeader: ReactionPickerCategoryHeader,
        Emoji: ReactionPickerEmoji,
      }}
    />
  </EmojiPicker.Viewport>
)
const ReactionPickerRoot = ({ onSelect, selectedEmojis }) => {
  const handleEmojiSelect = useCallback((e) => onSelect(e.emoji), [onSelect])
  return (
    <SelectedEmojisContext.Provider value={selectedEmojis}>
      <EmojiPicker.Root className="flex flex-col h-full w-full" onEmojiSelect={handleEmojiSelect}>
        <ReactionPickerSearch />
        <ReactionPickerViewport />
      </EmojiPicker.Root>
    </SelectedEmojisContext.Provider>
  )
}
export const ReactionPicker = memo(({ onSelect, selectedEmojis = [] }) => {
  return (
    <div className="flex flex-col h-[320px] w-full bg-popover text-popover-foreground border-none rounded-xl overflow-hidden">
      <ReactionPickerRoot onSelect={onSelect} selectedEmojis={selectedEmojis} />
    </div>
  )
})
ReactionPicker.displayName = 'ReactionPicker'
